import { white } from '@synoptic/ui-kit/palette.ts';
import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { globalStyle, style } from '@vanilla-extract/css';
import { menuItemLinkCommonStyles } from './menu/menu-action/menu-action.css';
import { sidebarWrapperCollapsed } from './sidebar.css';

export const profileMenu = style([
  {
    overflow: 'hidden',
  },
  responsiveStyle({
    mobile: {
      backgroundColor: white[50],
      borderRadius: borderRadius.r12,
      border: `1px solid ${white[100]}`,
    },
    tablet: {
      backgroundColor: 'transparent',
      borderRadius: 0,
      border: `none`,
      margin: 0,
    },
    laptop: {
      backgroundColor: white[50],
      borderRadius: borderRadius.r12,
      border: `1px solid ${white[100]}`,
      margin: `0px ${space.s24}px`,
    },
  }),
]);

globalStyle(`.${sidebarWrapperCollapsed} .${profileMenu}`, {
  backgroundColor: 'transparent',
  borderRadius: 0,
  border: `none`,
  margin: 0,
});

export const profileMenuTrigger = style([
  {
    all: 'unset',
    boxSizing: 'border-box',
    display: 'grid',
    color: white[900],
    gap: space.s20,
    padding: space.s14,
    transition: '.1s',
  },
  responsiveStyle({
    mobile: {
      gridTemplateColumns: 'min-content 1fr',
      margin: '0',
      width: '100%',

      ':hover': {
        backgroundColor: 'transparent',
        cursor: 'default',
      },
    },
    tablet: {
      gridTemplateColumns: '1fr',
      margin: '0 auto',
      width: 'auto',
      transition: 'none',
      paddingLeft: 0,
      paddingRight: 0,

      ':hover': {
        cursor: 'pointer',
      },
    },
    laptop: {
      gridTemplateColumns: 'min-content 1fr',
      margin: '0',
      width: '100%',
      padding: space.s14,

      ':hover': {
        backgroundColor: white[50],
      },
    },
  }),
]);

globalStyle(`.${sidebarWrapperCollapsed} .${profileMenuTrigger}`, {
  gridTemplateColumns: '1fr',
  margin: '0 auto',
  width: 'auto',
  transition: 'none',
  paddingLeft: 0,
  paddingRight: 0,
});

globalStyle(`.${sidebarWrapperCollapsed} .${profileMenuTrigger}:hover`, {
  backgroundColor: 'transparent',
});

export const contentContainer = style({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
});

export const heading = style({
  ...typography['titleSm'],
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const username = style({
  ...typography['bodyMd'],
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const profileMenuContent = style([
  {
    borderTop: `1px solid ${white[100]}`,
    display: 'flex',
    flexDirection: 'column',
    padding: `${space.s20}px ${space.s14}px`,
    alignItems: 'center',
  },
  responsiveStyle({
    mobile: {
      padding: `${space.s20}px ${space.s14}px`,
    },
    tablet: {
      padding: `${space.s10}px ${space.s14}px`,
    },
    laptop: {
      padding: `${space.s20}px ${space.s14}px`,
    },
  }),
]);

globalStyle(`.${sidebarWrapperCollapsed} .${profileMenuContent}`, {
  padding: `${space.s10}px ${space.s14}px`,
});

globalStyle(`.${sidebarWrapperCollapsed} .${profileMenuContent}`, {
  padding: `${space.s10}px ${space.s14}px`,
});

export const profileMenuItem = style([
  {
    padding: space.s12,
    transition: 'none',
    width: '100%',
    whiteSpace: 'nowrap',
  },
  responsiveStyle({
    mobile: {
      ...typography['labelLg'],
      borderRadius: borderRadius.r12,
      gap: menuItemLinkCommonStyles.tablet.gap,
      flexDirection: 'row',
      maxHeight: 'max-content',
      justifyContent: 'start',
    },
    tablet: {
      width: '48px',
      height: '48px',
    },
    laptop: {
      width: '100%',
    },
  }),
]);

export const profileMenuButton = style([
  profileMenuItem,
  {
    ':disabled': {
      backgroundColor: 'initial',
      color: 'inherit',
    },
  },
  responsiveStyle({
    mobile: {
      ...typography['labelLg'],
      borderRadius: borderRadius.r12,
      gap: menuItemLinkCommonStyles.tablet.gap,
      flexDirection: 'row',
      maxHeight: 'max-content',
      justifyContent: 'start',
    },
  }),
]);

export const profileMenuSwitch = style({
  marginLeft: 'auto',
});

globalStyle(`.${profileMenuItem} :where(svg)`, {
  height: 24,
  width: 24,
  flexShrink: 0,
});
